import axios from "axios";
import { adminDomain, orikamiDomain } from "../urlConst/domainUrl";

// const API_URL_LOGIN = 'https://orikomi-quote-api.107.jp/api/v1/manager_login'
const API_URL_LOGIN = orikamiDomain + "/api/v1/admin/login";

const API_URL_LOGOUT = adminDomain + "/api/v1/admin_logout";
// const API_URL_LOGOUT = 'https://orikomi-quote-api.107.jp/api/v1/manager_logout'

const API_URL_ORDER_STATUS =
  orikamiDomain + "/api/v1/order/count_since_last_logout";
// const API_URL_ORDER_STATUS =
//   'https://orikomi-quote-api.107.jp/api/v1/order/count_since_last_logout'

const API_URL_ORDERDISTRIBUTION_STATUS =
  orikamiDomain + "/api/v1/order/status_list";

const API_URL_MY_PROFILE = adminDomain + "/api/v1/my_account";
// Get Order Status
// @GET
const getDistributionStatus = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_ORDERDISTRIBUTION_STATUS, null, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

const fetchMyProfile = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.get(API_URL_MY_PROFILE, config);
  return res;
};

// Get Order Status
// @GET
const getOrderStatus = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_ORDER_STATUS, null, config);

  return res.data;
};

// Get Order
// @POST
const getToken = async (data) => {
  const res = await axios.post(API_URL_LOGIN, data);

  return res;
};

// Logout
// @GET
const logout = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_LOGOUT, null, config);

  return res;
};

const saveService = {
  getToken,
  logout,
  getOrderStatus,
  getDistributionStatus,
  fetchMyProfile,
};

export default saveService;
